/**
 * @generated SignedSource<<bb8c53cbf8159801a345c7dce1caa0ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RespondedFrom = "email" | "mobile" | "slack" | "web";
export type SkipPulseInput = {
  clientMutationId?: string | null;
  pulseId: string;
  respondedFrom: RespondedFrom;
};
export type skipPulseResponseMutation$variables = {
  input: SkipPulseInput;
};
export type skipPulseResponseMutationVariables = skipPulseResponseMutation$variables;
export type skipPulseResponseMutation$data = {
  readonly skipPulse: {
    readonly user: {
      readonly tasksList: ReadonlyArray<{
        readonly __typename: "RespondToPulseTask";
        readonly id: string;
        readonly pulseGroup: {
          readonly entityId: string;
        } | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null>;
    } | null;
    readonly pulse: {
      readonly id: string;
      readonly skippedAt: DateString | null;
      readonly respondedFrom: RespondedFrom | null;
      readonly question: {
        readonly id: string;
        readonly body: string;
      };
      readonly pulseGroup: {
        readonly remainingPulses: ReadonlyArray<{
          readonly id: string;
          readonly question: {
            readonly currentRevision: {
              readonly id: string;
            } | null;
            readonly body: string;
            readonly hasComment: boolean;
          };
        }>;
        readonly totalPulsesCount: number;
        readonly remainingPulsesCount: number;
        readonly skippedPulsesCount: number;
      };
    } | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type skipPulseResponseMutationResponse = skipPulseResponseMutation$data;
export type skipPulseResponseMutation = {
  variables: skipPulseResponseMutationVariables;
  response: skipPulseResponseMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skippedAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "respondedFrom",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v8 = [
  (v3/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasComment",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalPulsesCount",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remainingPulsesCount",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skippedPulsesCount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "skipPulseResponseMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SkipPulsePayload",
        "kind": "LinkedField",
        "name": "skipPulse",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "tasksList",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PulseGroup",
                        "kind": "LinkedField",
                        "name": "pulseGroup",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "RespondToPulseTask",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Pulse",
            "kind": "LinkedField",
            "name": "pulse",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "question",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PulseGroup",
                "kind": "LinkedField",
                "name": "pulseGroup",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Pulse",
                    "kind": "LinkedField",
                    "name": "remainingPulses",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "question",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "currentRevision",
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "currentRevisionV2",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          },
                          (v7/*: any*/),
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "skipPulseResponseMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SkipPulsePayload",
        "kind": "LinkedField",
        "name": "skipPulse",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "tasksList",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PulseGroup",
                        "kind": "LinkedField",
                        "name": "pulseGroup",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "RespondToPulseTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "ApprovePeerNominationsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "CalibrateTalentReviewTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "ConfirmReceivingPacketTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "CreateGoalForGoalCycleTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "DocumentsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "EnableOneOnOneTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "EndRevieweeCycleTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "FinalizeReviewPacketTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "GiveFeedbackTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "PTORequestTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "PerformPostScoringReviewTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "PerformReviewsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "PerformTalentReviewTaskType",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "PublishGrowthAreaReminderTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "RespondToBackboneEmployeeRegistrationFormTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "RespondToSurveyAssignmentTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "RespondToSurveyTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "ReviewCompensationCycleTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "ReviewReportCheckinTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "ScoreRevieweeTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "SelectPeersTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "SetupOneOnOnesWithNewReportTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "SetupUpdatesWithNewReportTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "ShareCompensationCycleResultsToTeamTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "StartSurveyManagerActionPlanningTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "UpdateGoalTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "UpdateGoalsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "UpdateTotalRewardsCompanyCurrencyTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "ViewCalibrationGroupsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "ViewCompensationCycleResultsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "ViewCompensationCycleTeamResultsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "ViewCompensationTotalRewardsStatementTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "ViewSharedCompensationCycleResultsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "ViewSurveyActionPlanTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "ViewSurveyCommentTask",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Pulse",
            "kind": "LinkedField",
            "name": "pulse",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "question",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PulseGroup",
                "kind": "LinkedField",
                "name": "pulseGroup",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Pulse",
                    "kind": "LinkedField",
                    "name": "remainingPulses",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "question",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": "currentRevision",
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "currentRevisionV2",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v7/*: any*/),
                          (v9/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0880ab33282d447cff01b8b691f08496",
    "id": null,
    "metadata": {},
    "name": "skipPulseResponseMutation",
    "operationKind": "mutation",
    "text": "mutation skipPulseResponseMutation(\n  $input: SkipPulseInput!\n) {\n  skipPulse(input: $input) {\n    user {\n      tasksList {\n        __typename\n        ... on RespondToPulseTask {\n          id\n          pulseGroup {\n            entityId\n            id\n          }\n        }\n        ... on ApprovePeerNominationsTask {\n          id\n        }\n        ... on CalibrateTalentReviewTask {\n          id\n        }\n        ... on ConfirmReceivingPacketTask {\n          id\n        }\n        ... on CreateGoalForGoalCycleTask {\n          id\n        }\n        ... on DocumentsTask {\n          id\n        }\n        ... on EnableOneOnOneTask {\n          id\n        }\n        ... on EndRevieweeCycleTask {\n          id\n        }\n        ... on FinalizeReviewPacketTask {\n          id\n        }\n        ... on GiveFeedbackTask {\n          id\n        }\n        ... on PTORequestTask {\n          id\n        }\n        ... on PerformPostScoringReviewTask {\n          id\n        }\n        ... on PerformReviewsTask {\n          id\n        }\n        ... on PerformTalentReviewTaskType {\n          id\n        }\n        ... on PublishGrowthAreaReminderTask {\n          id\n        }\n        ... on RespondToBackboneEmployeeRegistrationFormTask {\n          id\n        }\n        ... on RespondToSurveyAssignmentTask {\n          id\n        }\n        ... on RespondToSurveyTask {\n          id\n        }\n        ... on ReviewCompensationCycleTask {\n          id\n        }\n        ... on ReviewReportCheckinTask {\n          id\n        }\n        ... on ScoreRevieweeTask {\n          id\n        }\n        ... on SelectPeersTask {\n          id\n        }\n        ... on SetupOneOnOnesWithNewReportTask {\n          id\n        }\n        ... on SetupUpdatesWithNewReportTask {\n          id\n        }\n        ... on ShareCompensationCycleResultsToTeamTask {\n          id\n        }\n        ... on StartSurveyManagerActionPlanningTask {\n          id\n        }\n        ... on UpdateGoalTask {\n          id\n        }\n        ... on UpdateGoalsTask {\n          id\n        }\n        ... on UpdateTotalRewardsCompanyCurrencyTask {\n          id\n        }\n        ... on ViewCalibrationGroupsTask {\n          id\n        }\n        ... on ViewCompensationCycleResultsTask {\n          id\n        }\n        ... on ViewCompensationCycleTeamResultsTask {\n          id\n        }\n        ... on ViewCompensationTotalRewardsStatementTask {\n          id\n        }\n        ... on ViewSharedCompensationCycleResultsTask {\n          id\n        }\n        ... on ViewSurveyActionPlanTask {\n          id\n        }\n        ... on ViewSurveyCommentTask {\n          id\n        }\n      }\n      id\n    }\n    pulse {\n      id\n      skippedAt\n      respondedFrom\n      question {\n        __typename\n        id\n        body\n      }\n      pulseGroup {\n        remainingPulses {\n          id\n          question {\n            __typename\n            currentRevision: currentRevisionV2 {\n              __typename\n              id\n            }\n            body\n            hasComment\n            id\n          }\n        }\n        totalPulsesCount\n        remainingPulsesCount\n        skippedPulsesCount\n        id\n      }\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "1625a8221f54fbc887bcc2576b3c067a";

export default node;
